"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function($http, $q) {
  var that = this;

  var nameAndUrlList = [
    {
      name: "OpenFin Web Client",
      url: "/openfin/version"
    },
    {
      name: "IdP",
      url: "/idp/oauth2"
    },
    {
      name: "Ref Data",
      url: "/ref-data/webapi"
    },
    {
      name: "Workspace",
      url: "/workspaces/webapi"
    },
    {
      name: "Data Services",
      url: "/dataservices/version"
    },
    {
      name: "Spread Trader Client",
      url: "/spread-trader/version"
    },
    {
      name: "Spread Trader Leftover",
      url: "/spread-trader/webapi"
    },
    {
      name: "Spread Trader Presentation",
      url: "/spread-trader/webapi/about"
    },
    {
      name: "Chart IQ",
      url: "/chartiq/version"
    },
    {
      name: "Risk Manager",
      url: "/riskmanager/webapi"
    },
    {
      name: "Stock Loan Manager",
      url: "/stockloanmanager/webapi"
    },
    {
      name: "Allocations",
      url: "/redi/allocations/webapi"
    },
    {
      name: "Product Availability Checker",
      url: "/redi/productchecker/webapi"
    },
    {
      name: "Commissions",
      url: "/redi/commissions/webapi"
    }
  ];

  that.getAll = function() {
    return $q.all(
      _.map(nameAndUrlList, function(nameAndUrl) {
        return $http.get(nameAndUrl.url).then(
          function(result) {
            return {
              name: nameAndUrl.name,
              success: true,
              data: result.data
            };
          },
          function(result) {
            return {
              name: nameAndUrl.name,
              success: false,
              data: result
            };
          }
        );
      })
    );
  };
};



// WEBPACK FOOTER //
// ./app/business/componentRepository.js